import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useCurrentClient } from '../../../api/clients'

const useStyleVariant = (className, style, variant) => {
  return useMemo(() => {
    if (variant === 'wheel') {
      return [className,
        {
          fontSize: 'min(42px, 4.5vh)',
          fontWeight: 300,
          fontFamily: 'GothamPro-Bold,Gotham-Book,"Open Sans",Tahoma,"Segoe UI",sans-serif',
          ...(style || {})
        }]
    }
    return [className, style]
  }, [className, style, variant])
}

const useFamilyName = (client) => {
  return useMemo(() => {
    if (!client?.longName) return 'Please select a Client'
    if (client?.longName.length > 50) {
      return client?.longName.substring(0, client?.longName.lastIndexOf(' '))
    } else {
      return client?.longName
    }
  }, [client])
}

function CurrentClientName ({ className, style, variant }) {
  const { data: client, isLoading } = useCurrentClient()
  const familyName = useFamilyName(client)
  const [_className, _style] = useStyleVariant(className, style, variant)

  if (isLoading) {
    return null
  }

  return (
    <div className={_className} style={_style}>
      {familyName}
    </div>
  )
}

CurrentClientName.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  variant: PropTypes.oneOf(['wheel', 'none'])
}

CurrentClientName.defaultProps = {
  variant: 'none'
}

export default CurrentClientName
